import "./App.css";
import Routes from "./routes/Routes";
import React from "react";
import toast, { Toaster } from "react-hot-toast";

const App = () => {
  // const devtools = new Function("debugger");
  // setInterval(() => {
  //   devtools();
  // }, 1000);
  // document.addEventListener("contextmenu", (event) => event.preventDefault());
  // document.addEventListener("keydown", (event) => {
  //   if (
  //     (event.ctrlKey &&
  //       (event.key === "u" ||
  //         event.key === "U" ||
  //         event.key === "i" ||
  //         event.key === "I" ||
  //         event.key === "s" ||
  //         event.key === "S")) ||
  //     event.key === "F12"
  //   ) {
  //     event.preventDefault();
  //   }
  // });

  // let devtoolsOpen = false;
  // const element = new Image();
  // Object.defineProperty(element, "id", {
  //   get: function () {
  //     devtoolsOpen = true;
  //     throw new Error("DevTools detected");
  //   },
  // });

  // setInterval(() => {
  //   devtoolsOpen = false;
  //   console.log(element); // This triggers the getter
  //   if (devtoolsOpen) {
  //     toast.error("Please close Developer Tools.");
  //   }
  // }, 1000);

  return (
    <>
      <Routes />
      <Toaster
        toastOptions={{
          duration: 5000,
        }}
      />
    </>
  );
};

export default App;
